/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Usermanagement_Invite_Emailstepdescription23Inputs */

const en_usermanagement_invite_emailstepdescription23 = /** @type {(inputs: Usermanagement_Invite_Emailstepdescription23Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`By adding a user, you confirm granting them access to the funds specified in the next step`)
};

/**
* | output |
* | --- |
* | "By adding a user, you confirm granting them access to the funds specified in the next step" |
*
* @param {Usermanagement_Invite_Emailstepdescription23Inputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
const usermanagement_invite_emailstepdescription23 = /** @type {((inputs?: Usermanagement_Invite_Emailstepdescription23Inputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Usermanagement_Invite_Emailstepdescription23Inputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_usermanagement_invite_emailstepdescription23(inputs)
});
export { usermanagement_invite_emailstepdescription23 as "userManagement_invite_emailStepDescription2" }